module.exports = __webpack_public_path__ + "3565d84e0ee9622650426328a980091e.png";